"use strict";
exports.__esModule = true;
exports.FINANCIALS = void 0;
var FINANCIALS = {
    ACCOUNT_TYPE: {
        INCOME: 'income',
        EXPENSE: 'expense',
        LIABILITY: 'liability',
        ASSET: 'asset'
    },
    OWNERSHIP_TYPE: {
        CLIENT: 'client_only',
        CLIENT_AND_PARTNER: 'client_and_partner',
        CLIENT_AND_OTHER: 'client_and_other'
    },
    LIABILITY_OWNERSHIP: {
        SELF: 'self',
        SHARED: 'shared'
    }
};
exports.FINANCIALS = FINANCIALS;
